<template>
  <v-menu
    ref="menu"
    v-bind="$attrs"
    v-model="menu"
    :close-on-content-click="false"
    :value="value"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="formatDate"
        :label="label"
        prepend-icon="mdi-calendar"
        clearable
        readonly
        v-bind="$attrs"
        v-on="on"
        @click:clear="updateValue(null)"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" no-title scrollable v-bind="$attrs">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
      <v-btn text color="primary" @click="updateValue(date)">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
export default {
  name: "MenuDatePicker",
  props: {
    value: {
      type: [Object, String],
      required: false
    },
    label: {
      type: String,
      required: true
    }
  },
  data: () => ({
    menu: null,
    date: ""
  }),
  methods: {
    updateValue(value) {
      this.date = value;
      this.$refs.menu.save(String(value));
      this.$emit("input", value);
    }
  },
  computed: {
    formatDate: {
      get() {
        return this.date ? moment(this.date).format("DD.MM.YYYY") : "";
      },
      set(value) {
        // this.updateValue(value);
        this.date = value;
        this.$refs.menu.save(value);
      }
    }
  },
  watch: {
    value(val) {
      //this.updateValue(val);
      this.date = val;
      this.$refs.menu.save(val);
    }
  },
  created() {
    if (this.value) {
      this.date = moment(this.value).format("YYYY-MM-DD");
    }
  }
};
</script>
